document.addEventListener('DOMContentLoaded', () => {
    const buttons = document.querySelectorAll<HTMLButtonElement>('.play-banner-video-button');

    buttons.forEach(button => {
        button.addEventListener('click', () => {
            // eslint-disable-next-line no-console
            console.log(button, ' clicked');
            const targetId = button.getAttribute('data-target');
            if (!targetId) {
                return;
            }

            const video = document.getElementById(targetId) as HTMLVideoElement | null;
            if (video) {
                video.play().catch(err => {
                    console.error('Failed to play video:', err);
                });
                button.style.display = 'none';
            }
        });
    });
});
